
//Libraries
import { defineComponent, onMounted, onUnmounted, ref } from "vue";

//Services
import { runDropdown } from "../services/dom-service";

//Components
import NotificationBar from "./NotificationBar.vue";

export default defineComponent({
  name: "NavBar",
  components: {
    NotificationBar,
  },
  setup() {
    //Data

    const isNotificationBarVisible = ref<boolean>(false);
    const isFixedNav = ref<boolean>(false);

    //Methods

    const executeDropDown = (isActive: boolean, dropdownId: string) => {
      runDropdown(isActive, dropdownId);
    };

    const activeNotificationBar = () => {
      isNotificationBarVisible.value = true;
    };

    const hideNotificationBar = () => {
      isNotificationBarVisible.value = false;
    };

    const fixNav = () => {
      const navHeight = document.getElementById("nav-bar")?.clientHeight;
      if (window.scrollY > (navHeight ? navHeight : 0) + 100) isFixedNav.value = true;
      else isFixedNav.value = false;
    };

    //Lifecycle Hooks

    onMounted(() => {
      window.addEventListener("scroll", () => {
        executeDropDown(false, "account-dropdown");
        fixNav();
      });
    });

    onUnmounted(() => {
      window.removeEventListener("scroll", () => {
        executeDropDown(false, "account-dropdown");
      });
    });

    return {
      //Data
      isFixedNav,
      isNotificationBarVisible,
      //Methods
      activeNotificationBar,
      hideNotificationBar,
      executeDropDown,
    };
  },
});
